import { combineReducers } from "@reduxjs/toolkit";
import alert from './alert';
import auth from './auth';
import data from './data';
import master from './master';
import data2 from './data2';


export default combineReducers({
  alert,
  auth,
  data,
  data2,
  master,
})
